import axiosInstance from "../../utils/axiosInstance";

const getHoleInOneRule = async () => {
  const response = await axiosInstance.get(
    `hole-in-one-rule`
  );
  return response.data.data;
};

const updateHoleInOneRule = async (params) => {
  const response = await axiosInstance.post(`hole-in-one-rule`, params);
  return response.data.data;
};

const holeInOneRuleService = {
  getHoleInOneRule,
  updateHoleInOneRule,
};

export default holeInOneRuleService;
